<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-8">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-8"
                          body-classes="px-lg-8 py-lg-8"
                          class="border-0" v-if="url_panel_show_flag">
                        <template>
                            <div class="alert alert-warning" role="alert" v-if="need_data_flag">
                                Download link is required.
                            </div>
                            <form role="form">
                                <base-input alternative
                                            class="mb-3"
                                            placeholder="Your Download (Include http:// or https://)"
                                            addon-left-icon="ni ni-spaceship" v-model="targetlink">
                                </base-input>
                                <base-input alternative
                                            type="password"
                                            placeholder="Link Management Password"
                                            addon-left-icon="ni ni-lock-circle-open" v-model="targetpassword">
                                </base-input>
                                <div class="text-center">
                                    <base-button type="primary" class="my-4" @click="submitfunction">Submit
                                    </base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>


                <card type="secondary" shadow
                      header-classes="bg-white pb-5"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0" v-if="!url_panel_show_flag">
                    <template>
                        <form role="form">
                            <div class="alert alert-success" role="alert">
                                Your Link (Valid 14 days): <a :href="result_short_url" class="alert-link"
                                                 v-text="result_short_url" target="view_window"></a>
                            </div>

                            <div id="query">
                                <h4 type="primary" class="text-primary">QR code:</h4>
                                <div id="qrcode" ref="qrcode"></div>
                            </div>


                            <div class="text-center">
                                <base-button type="primary" class="my-4" @click="resetfunction">Reset</base-button>
                            </div>
                        </form>
                    </template>
                </card>


            </div>
        </div>
    </section>
</template>
<script>
    import QRCode from "qrcodejs2"
    import axios from "axios";

    export default {
        data() {
            return {
                url_panel_show_flag: true,
                need_data_flag: false,
                result_short_url: this.GLOBAL.serverSrc,
                targetlink: "",
                targetpassword: ""
            }
        },
        methods: {
            submitfunction: function () {
                if (this.targetlink !== "") {
                    this.url_panel_show_flag = false;

                    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                    axios
                        .post(this.GLOBAL.serverSrc+'/apiv1document/clouddownloadpostservicecenter/', {
                            link: this.targetlink,
                            managepassword: this.targetpassword
                        })
                        .then(response => {
                            console.log(response)
                            this.result_short_url = response.data;
                            this.result_short_url = this.GLOBAL.serverSrc+"/" + this.result_short_url;
                            console.log(response.data.link, this.result_short_url);


                            this.targetpassword = "";
                            this.targetlink = "";
                            this.need_data_flag = false;
                            this.$nextTick(() => {
                                this.qrcode(this.result_short_url)
                            })


                        })
                        .catch(error => console.log(error))
                    // .finally(() => this.loading = false)


                } else {
                    this.need_data_flag = true;
                }

            },
            resetfunction: function () {
                this.url_panel_show_flag = true;
                this.need_data_flag = false;
                this.result_short_url = ""

            },
            qrcode(address) {

                let qrcode = new QRCode('qrcode', {
                    width: 300, // 设置宽度，单位像素
                    height: 300, // 设置高度，单位像素
                    text: address  // 设置二维码内容或跳转地址
                })
            }

        },

    };
</script>
<style>

</style>
